<template>
  <transition name="agreement-dialog-fade">
    <div v-if="visible" class="agreement-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭用户协议弹窗" @click="handleClose" />

        <h3 class="title">{{ currentTitle }}</h3>

        <div class="body">
          <div v-if="loading" class="status-text">加载中...</div>
          <div v-else-if="contentHtml" class="rich-text" v-html="contentHtml" />
          <div v-else class="status-text">暂无内容</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const AGREEMENT_CONFIG = {
  agreement: {
    id: 120,
    title: "用户协议",
  },
  privacy: {
    id: 109,
    title: "隐私政策",
  },
  fee: {
    id: 289,
    title: "收费标准",
  },
};

export default {
  name: "AgreementDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      contentHtml: "",
    };
  },
  computed: {
    currentConfig() {
      return AGREEMENT_CONFIG[this.dialogKey] || null;
    },
    currentTitle() {
      return this.currentConfig ? this.currentConfig.title : "";
    },
    activeDialogKey() {
      return this.visible ? this.dialogKey : "";
    },
  },
  watch: {
    activeDialogKey(value) {
      if (!value) {
        return;
      }

      this.fetchContent(value);
    },
  },
  methods: {
    async fetchContent(dialogKey = this.dialogKey) {
      const config = AGREEMENT_CONFIG[dialogKey] || null;

      if (!config) {
        this.contentHtml = "";
        return;
      }

      this.loading = true;
      this.contentHtml = "";

      try {
        const res = await this.$api({
          url: "Txt/show",
          method: "get",
          data: {
            id: config.id,
            lang: "zh",
          },
        });

        if (res.code !== 200) {
          this.$message.error(res.msg || `${config.title}获取失败`);
          return;
        }

        const contentHtml = (res.data && res.data.content_html) || "";

        if (!contentHtml) {
          this.$message.warning(`${config.title}暂无内容`);
          return;
        }

        if (this.dialogKey === dialogKey) {
          this.contentHtml = contentHtml;
        }
      } catch (error) {
        this.$message.error(`${config.title}获取失败，请稍后重试`);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.agreement-dialog {
  position: fixed;
  inset: 0;
  z-index: 1998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  box-sizing: border-box;
  width: 960px;
  max-width: 100%;
  padding: 22px 28px 28px;
  background: #ffffff;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.24);
}

.close {
  position: absolute;
  top: 18px;
  right: 20px;
  width: 14px;
  height: 14px;
  border: 0;
  padding: 0;
  background: url("../../../assets/home-confirm/dialogs/close.svg") center / 14px 14px no-repeat;
  cursor: pointer;
}

.title {
  margin: 0;
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
}

.body {
  margin-top: 20px;
  padding: 24px 26px;
  max-height: 70vh;
  overflow-y: auto;
  background: #ffffff;
}

.status-text {
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
}
</style>
